let appConfig;

export const storeApplicationConfiguration = (config) => {
    appConfig = {
        recaptcha: {
            key: config?.featureConfig?.recaptcha?.key,
        },
        programCode: config?.programCode,
        resourcePath: config?.resourcePath,
        brandMediaPath: `${config?.resourcePath}${config?.branding?.mediaPath}`,
        features: config?.features && [...config.features],
        applicationId: config?.applicationId,
        productCode: config?.productCode,
    };
};

export const getApplicationConfig = (key) => {
    if (appConfig && key in appConfig && appConfig[key]) {
        return appConfig[key];
    }

    return undefined;
};

export const applicationConfig = () => {
    return appConfig;
};
